import React, { useCallback } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router-dom";
import TabPanel, { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import TextArea from 'devextreme-react/text-area';
import Accordion from 'devextreme-react/accordion';
import { CheckBox } from "devextreme-react/check-box";
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { confirm } from "devextreme/ui/dialog";
import { LoadPanel as DivLoadPanel } from 'devextreme-react/load-panel';
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import { GridLayout } from "../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    Editing,
    ColumnFixing,
    StateStoring,
    Toolbar,
    Item,
    Selection,
    Scrolling,
    Lookup,
} from "devextreme-react/data-grid";
import ToolbarHdr, { Item as ItemHdr } from "devextreme-react/toolbar";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { GetFormatedDateWithTime } from '../../../common/Utils';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../../common/concurrency";
import { MESSAGES } from "../../../common/Messages";
import { ItemTypeFlag, LotStatus } from "../../../const/Lookup";
import { EMPTY_GUID } from "../../../const/constants";
import UserDefinedFieldsTab, {
    USER_DEFINED_FIELD_COUNT,
    emptyUserDefinedFields,
    emptyUserDefinedCodeOptions,
    userDefinedFieldsFromProfile,
    userDefinedCodeOptions,
    userDefinedFieldsForRequest,
} from "./UserDefinedFieldsTab";

// Stage/Status codes the screen applies rules to (WMTRANSACTIONHEADER.STAGE / STATUS).
const STAGE_COMPLETED = 'C';
// Legacy ApplyProfile defaults a blank stage to Ready (uWM_frmTransactionHeaderDEADO.pas:424-426).
const STAGE_READY = 'R';
const STATUS_OPEN = 'O';
const STATUS_READY_TO_COMMIT_LATER = 'L';
const MESSAGE_SEPARATOR = '<br/>';
// IMITEM.ITEMCODE is char(20): the longest receiving Item Code (OwnershipTransferConstants.ItemCodeMaxLength).
const ITEM_CODE_MAX_LENGTH = 20;
// The Select Inventory grid fields the user edits: legacy Transfer, AsItemCode and Weight.
const EDITABLE_FIELD = {
    QUANTITY: 'quantityorder',
    ITEM_CODE: 'receivingitemcode',
    WEIGHT: 'weightQuantity',
};
// Lot and sublot rows have a lot; an item-only (item type I) row's Rlot is the empty Guid.
const hasLot = (row) => !!row?.rlot && row.rlot !== EMPTY_GUID;
// A level's User Defined Code/Date/Quantity/Reference 1-10 grid columns, read from the row's level object
// (e.g. "lotUserDefined"); hidden, as the legacy Item/Lot/SubLot/Location grids have them.
const USER_DEFINED_KINDS = [
    { name: 'code', caption: 'Code', dataType: 'string' },
    { name: 'date', caption: 'Date', dataType: 'date' },
    { name: 'quantity', caption: 'Quantity', dataType: 'number' },
    { name: 'reference', caption: 'Reference', dataType: 'string' },
];
const userDefinedColumns = (field, level) => USER_DEFINED_KINDS.flatMap(kind =>
    Array.from({ length: USER_DEFINED_FIELD_COUNT }, (_, index) => {
        const dataField = `${field}.${kind.name}${index + 1}`;
        return <Column key={dataField} dataField={dataField} caption={`${level} ${kind.caption} ${index + 1}`} dataType={kind.dataType} allowEditing={false} visible={false}></Column>;
    }));
const statusColumn = (dataField, caption) => (
    <Column key={dataField} dataField={dataField} caption={caption} allowEditing={false} visible={false}>
        <Lookup dataSource={LotStatus} valueExpr="key" displayExpr="value" />
    </Column>
);

let accessToken = '';
let oidc = '';
const shipmentCustomerSelectBox = React.createRef();
const shipmentShipperSelectBox = React.createRef();
const shipmentConsigneeSelectBox = React.createRef();
const shipmentStageSelectBox = React.createRef();
const shipmentStatusSelectBox = React.createRef();
const shipmentRateSchdSelectBox = React.createRef();

const receiptDatabaseSelectBox = React.createRef();
const receiptCompanyidSelectBox = React.createRef();
const receiptProfileSelectBox = React.createRef();
const receiptCustomerSelectBox = React.createRef();
const receiptShipperSelectBox = React.createRef();
const receiptConsigneeSelectBox = React.createRef();
const receiptStageSelectBox = React.createRef();
const receiptStatusSelectBox = React.createRef();
const receiptRateSchdSelectBox = React.createRef();
const receiptItemProfileSelectBox = React.createRef();
const receiptWarehouseSelectBox = React.createRef();
const receiptLocationSelectBox = React.createRef();

let detailOTItemDataGrid = React.createRef();
const detailGridKey = "a6a411bc-b411-4403-aba1-3ad4f6d130c6";

class OwnershipTransferInternal extends React.Component {
    constructor(props) {
        super(props);
        oidc = props.oidc;
        accessToken = props.oidc.user.access_token;
        this.ShipmentFormValuesChanged = this.ShipmentFormValuesChanged.bind(this);
        this.ShipmentProfileChanged = this.ShipmentProfileChanged.bind(this);
        this.ShipmentCustomerChanged = this.ShipmentCustomerChanged.bind(this);
        this.ReceiptFormValuesChanged = this.ReceiptFormValuesChanged.bind(this);
        this.ReceiptCustomerValuesChanged = this.ReceiptCustomerValuesChanged.bind(this);
        this.DetailGridselectionChanged = this.DetailGridselectionChanged.bind(this);
        this.DatabaseValueChanged = this.DatabaseValueChanged.bind(this);
        this.CompanyIdValueChanged = this.CompanyIdValueChanged.bind(this);
        this.AccordionSelectionChanged = this.AccordionSelectionChanged.bind(this);
        this.onTabSelectionChanged = this.onTabSelectionChanged.bind(this);
        this.onShipmentClickNext = this.onShipmentClickNext.bind(this);
        this.onReceiptClickNext = this.onReceiptClickNext.bind(this);
        this.ReceiptProfileChanged = this.ReceiptProfileChanged.bind(this);
        this.SearchGridFilter = this.SearchGridFilter.bind(this);
        this.ResetGridFilter = this.ResetGridFilter.bind(this);
        this.LoadItemsGrid = this.LoadItemsGrid.bind(this);
        this.onEditorPreparing = this.onEditorPreparing.bind(this);
        this.onEditingStart = this.onEditingStart.bind(this);
        this.onApplyClick = this.onApplyClick.bind(this);
        this.ResetAll = this.ResetAll.bind(this);
        this.ReceiptWarehouseChanged = this.ReceiptWarehouseChanged.bind(this);
        // Sequence number of the receiving-facility load in flight (see LoadDatabasesAndCompanyIds).
        this.receiptFacilityLoadId = 0;
        // The receipt customer's items in the receiving facility, for the Selected Inventory Item Code dropdown.
        this.receivingItems = [];
        this.receivingItemsLoadId = 0;

        this.searchpanel = [
            {
                ID: 1,
                Title: 'Filter'
            }
        ];
        this.state = this.createInitialState();

        this.arrStage = [
            { id: 1, name: 'Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available', value: 'C' },
            { id: 2, name: 'Future Order - No Effect On Net Available, No Charges', value: 'F' },
            { id: 3, name: 'Pending - Effects Net Available, No Charges', value: 'N' },
            { id: 4, name: 'Plan - No Inventory Effect, No Charges', value: 'P' },
            { id: 5, name: 'Ready To Receive/Pick/Staged - Effects Available, No Charges', value: 'R' }
        ];
        this.arrStatus = [
            { id: 1, name: 'Hold', value: 'H' },
            { id: 2, name: 'Ready To Commit Later', value: 'L' },
            { id: 3, name: 'Open', value: 'O' },
            { id: 4, name: 'Commited', value: 'Z' },
        ];
    }
    setCurrentLayout = (value) => {
        this.setState({
            currentLayout: value
        });
    }
    // A fresh state object each time, so a Reset never reuses (or has mutated) a previous one.
    createInitialState() {
        const baseTransaction = {
            profileId: "",
            customerId: "",
            transDate: new Date(),
            transactionNo: "",
            shipperId: "",
            consigneeId: "",
            stage: "P",
            status: STATUS_OPEN,
            shipperBolNo: "",
            poReference: "",
            rateScheduleId: "",
            transGroup: "",
            comment: "",
            ...emptyUserDefinedFields(),
        };
        return {
            selectedItems: [this.searchpanel[0]],
            currentLayout: "Default",
            searchPanelStatus: true,
            loadIndicatorVisible: false,
            selectedTabIndex: 0,
            // Select Inventory's own tabs: 0 = Select Inventory, 1 = Selected Inventory.
            inventoryTabIndex: 0,
            isTabDisabled: true,
            isReceiptTabLoaded: false,
            isInventoryTabLoaded: false,
            // Set by a successful Apply: the screen then shows the created transactions read-only, as legacy did.
            appliedResult: null,
            // True from the first Apply click until its validate / insert round trip ends (see onApplyClick).
            applying: false,
            // The codes each side's User Defined Code 1-10 fields offer: the signed-in facility's for the shipment,
            // the receiving facility's for the receipt.
            userDefinedCodeOptions: {
                shipment: emptyUserDefinedCodeOptions(),
                receipt: emptyUserDefinedCodeOptions(),
            },
            shipment: {
                ...baseTransaction,
                arrShipmentProfile: [],
                shipDate: new Date(),
                shipmentDisabled: true
            },
            receipt: {
                ...baseTransaction,
                databaseId: "",
                companyId: "",
                dbid: "",
                recvDate: new Date(),
                itemProfileId: "",
                transferUnspecifiedSerialNumbers: false,
                defaultWarehouseId: "",
                defaultLocationId: "",
                receiptDisabled: true
            },
            inventorySelection: {
                detailTransferQuantityCount: 0,
                ItemsGridDataFilterCriteria: {
                    Itemcodefrom: "",
                    Itemcodeto: "",
                    Lotcodefrom: "",
                    Lotcodeto: "",
                    Itemdescfrom: "",
                    Itemdescto: "",
                    Lotdescfrom: "",
                    Lotdescto: "",
                },
                selectedRowKeys: [],
                itemGridArr: [],
                // The rows of itemGridArr with a transfer quantity: the Selected Inventory tab's grid.
                selectedGridArr: [],
                selectedgriditems: [],
            }
        };
    }
    detailGridLoadState = () => { return GridLayout.sendStorageRequest(detailGridKey, "GET", accessToken,null,  this.state.currentLayout); }
    detailGridSaveState = (state) => { GridLayout.sendStorageRequest(detailGridKey, "POST", accessToken, state, this.state.currentLayout); }
    ResetAll(e) {
        if (e != null)
            e.event.stopPropagation();

        this.setState(this.createInitialState(), () => {
            this.LoadShipmentDropDowns();
        });
    }
    SearchGridFilter(e) {
        e.event.stopPropagation()
        this.LoadItemsGrid();
    }
    // Clears the filter only: rows already given a transfer quantity stay selected (legacy keeps selections
    // across filters), and the grid reloads with the cleared criteria.
    ResetGridFilter(e) {
        if (e != null && e != undefined) {
            e.event.stopPropagation()
            this.setState((prvState) => ({
                inventorySelection: {
                    ...prvState.inventorySelection,
                    ItemsGridDataFilterCriteria: this.createInitialState().inventorySelection.ItemsGridDataFilterCriteria
                }
            }), () => this.LoadItemsGrid());
        }
    }

    // Re-binding the facility list while a facility loads raises this event again for the same facility;
    // only a real change of facility reloads and clears the receipt side.
    DatabaseValueChanged(e) {
        const facility = e.selectedItem?.value;
        if (facility == null || String(facility) === String(this.state.receipt.databaseId))
            return;
        this.setState(prvState => ({
            userDefinedCodeOptions: { ...prvState.userDefinedCodeOptions, receipt: emptyUserDefinedCodeOptions() },
            receipt: {
                // Everything not reset below stays, and dbid moves to the new facility at once: while its lookups
                // load, "which facility is the receipt in" must not read as blank (a blank dbid counts as the
                // signed-in facility, which let the same-customer alert misfire).
                ...prvState.receipt,
                profileId: "",
                customerId: "",
                transDate: new Date(),
                transactionNo: "",
                shipperId: "",
                consigneeId: "",
                stage: "P",
                status: "O",
                shipperBolNo: "",
                poReference: "",
                rateScheduleId: "",
                transGroup: "",
                comment: "",
                ...emptyUserDefinedFields(),
                companyId: "",
                recvDate: new Date(),
                itemProfileId: "",
                transferUnspecifiedSerialNumbers: false,
                defaultWarehouseId: "",
                defaultLocationId: "",
                receiptDisabled: true,
                databaseId: e.selectedItem?.value,
                dbid: e.selectedItem?.value
            }
        }));
        this.LoadDatabasesAndCompanyIds(e.selectedItem?.value);
    }
    CompanyIdValueChanged(e) {
        this.setState(prvState => ({
            receipt: {
                ...prvState.receipt,
                profileId: "",
                customerId: "",
                transDate: new Date(),
                transactionNo: "",
                shipperId: "",
                consigneeId: "",
                stage: "",
                status: "",
                shipperBolNo: "",
                poReference: "",
                rateScheduleId: "",
                transGroup: "",
                comment: "",
                recvDate: new Date(),
                itemProfileId: "",
                transferUnspecifiedSerialNumbers: false,
                receiptDisabled: true,
                companyId: e.selectedItem.name
            }
        }));
        this.LoadDatabasesAndCompanyIds(e.selectedItem.value, false);
    }
    ShipmentFormValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            shipment: this.withStageRules(prvState.shipment, ctrlName, value),
            // The ship date carries over to the receipt's received date (legacy TransactionHeaderDataChange).
            ...(ctrlName === "shipDate" ? { receipt: { ...prvState.receipt, recvDate: value } } : {})
        }));
    }
    // Legacy cross-fill (TransactionHeaderDataChange, ApplyProfile): a shipment customer that is a shipper in
    // the receiving facility becomes the receipt's shipper; a receipt customer that is a consignee becomes
    // the shipment's consignee.
    receiptShipperFor(shipmentCustomerId, current) {
        return shipmentCustomerId && this.receiptShipperIds?.has(shipmentCustomerId) ? shipmentCustomerId : current;
    }
    shipmentConsigneeFor(receiptCustomerId, current) {
        return receiptCustomerId && this.shipmentConsigneeIds?.has(receiptCustomerId) ? receiptCustomerId : current;
    }
    // Status "Ready To Commit Later" is only allowed with Stage Completed: leaving Completed resets it to Open
    // (legacy edtStagePropertiesChange).
    withStageRules(header, ctrlName, value) {
        const updated = { ...header, [ctrlName]: value };
        if (ctrlName === "stage" && value !== STAGE_COMPLETED && updated.status === STATUS_READY_TO_COMMIT_LATER)
            updated.status = STATUS_OPEN;
        return updated;
    }
    statusItems(stage) {
        return stage === STAGE_COMPLETED
            ? this.arrStatus
            : this.arrStatus.filter(status => status.value !== STATUS_READY_TO_COMMIT_LATER);
    }
    // The receipt is in the signed-in (shipment) facility unless another facility is picked on the Receipt tab.
    isReceiptInShipmentFacility() {
        const dbid = this.state.receipt.dbid;
        if (!dbid || !oidc.user.profile.webUserInfo)
            return true;
        return String(dbid) === String(JSON.parse(oidc.user.profile.webUserInfo).userCompanyId);
    }
    // The same owner on both sides is only refused within one facility; moving a customer's stock to
    // another facility is allowed.
    ReceiptCustomerValuesChanged(e) {
        if (e.value && e.value === this.state.shipment.customerId && this.isReceiptInShipmentFacility()) {
            alert(MESSAGES.OWNERSHIP_TRANSFER_SAME_CUSTOMER, MESSAGES.WARNING).then(() => {
                this.setState(prvState => ({
                    receipt: {
                        ...prvState.receipt,
                        customerId: ""
                    }
                }));
            });
            return;
        }
        this.setState(prvState => ({
            receipt: {
                ...prvState.receipt,
                customerId: e.value
            },
            shipment: {
                ...prvState.shipment,
                consigneeId: this.shipmentConsigneeFor(e.value, prvState.shipment.consigneeId)
            }
        }));
    }
    ReceiptFormValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            receipt: this.withStageRules(prvState.receipt, ctrlName, value)
        }));
    }
    // Rebuilds the selection from a key -> quantity map: a row is selected exactly when it has a quantity,
    // and both tabs' grid rows and Transfer Totals follow from that. The receiving Item Code is one per source
    // item (item rowid -> code) and the Weight one per lot (lot rowid -> weight), so every selected row of an
    // item / lot carries the same value, a newly selected row included; each is kept while any of its rows stays
    // selected and dropped with the last, as legacy cleared AsItemCode on unselect.
    buildSelection(inventorySelection, quantities, {
        itemCodes = this.selectionItemCodes(inventorySelection),
        weights = this.selectionWeights(inventorySelection),
    } = {}) {
        const rowsByKey = new Map(inventorySelection.itemGridArr.map(row => [row.key, row]));
        const selectedgriditems = [...quantities]
            .filter(([, quantity]) => quantity > 0)
            .map(([selectedrowkey, quantityorder]) => {
                const row = rowsByKey.get(selectedrowkey);
                return {
                    selectedrowkey,
                    quantityorder,
                    receivingitemcode: itemCodes.get(row?.ritem) || "",
                    weightQuantity: hasLot(row) ? weights.get(row.rlot) || null : null,
                };
            });
        const selectionByKey = new Map(selectedgriditems.map(item => [item.selectedrowkey, item]));
        const itemGridArr = inventorySelection.itemGridArr.map(row => ({
            ...row,
            quantityorder: selectionByKey.get(row.key)?.quantityorder || 0,
            receivingitemcode: selectionByKey.get(row.key)?.receivingitemcode || "",
            weightQuantity: selectionByKey.get(row.key)?.weightQuantity || null,
        }));
        return {
            ...inventorySelection,
            selectedgriditems,
            selectedRowKeys: selectedgriditems.map(item => item.selectedrowkey),
            detailTransferQuantityCount: selectedgriditems.reduce((sum, item) => sum + item.quantityorder, 0),
            itemGridArr,
            selectedGridArr: itemGridArr.filter(row => selectionByKey.has(row.key)),
        };
    }
    selectionQuantities(inventorySelection) {
        return new Map(inventorySelection.selectedgriditems.map(item => [item.selectedrowkey, item.quantityorder]));
    }
    selectionItemCodes(inventorySelection) {
        return new Map(inventorySelection.selectedGridArr.map(row => [row.ritem, row.receivingitemcode]));
    }
    selectionWeights(inventorySelection) {
        return new Map(inventorySelection.selectedGridArr.filter(hasLot).map(row => [row.rlot, row.weightQuantity]));
    }
    // Changing the code on one row of an item changes it on every selected row of that item.
    setReceivingItemCode(itemRowId, itemCode) {
        this.setState((prevState) => {
            const itemCodes = this.selectionItemCodes(prevState.inventorySelection);
            itemCodes.set(itemRowId, (itemCode || "").trim());
            return {
                inventorySelection: this.buildSelection(prevState.inventorySelection, this.selectionQuantities(prevState.inventorySelection), { itemCodes })
            };
        });
    }
    // Changing the weight on one sublot row of a lot changes it on every selected row of that lot.
    setWeight(lotRowId, weight) {
        this.setState((prevState) => {
            const weights = this.selectionWeights(prevState.inventorySelection);
            weights.set(lotRowId, weight);
            return {
                inventorySelection: this.buildSelection(prevState.inventorySelection, this.selectionQuantities(prevState.inventorySelection), { weights })
            };
        });
    }
    // Item Code and Weight travel with the transfer, so a row takes them once it is selected (they are dropped when it
    // is unselected); Weight only on a row with a lot, as legacy has it on the Lot grid alone.
    onEditingStart(e) {
        const field = e.column?.dataField;
        if (field !== EDITABLE_FIELD.ITEM_CODE && field !== EDITABLE_FIELD.WEIGHT)
            return;
        if (!(e.data?.quantityorder > 0) || (field === EDITABLE_FIELD.WEIGHT && !hasLot(e.data)))
            e.cancel = true;
    }
    onEditorPreparing(e) {
        if (e.parentType !== 'dataRow')
            return;
        if (e.dataField === EDITABLE_FIELD.QUANTITY)
            this.prepareQuantityEditor(e);
        else if (e.dataField === EDITABLE_FIELD.ITEM_CODE)
            this.prepareReceivingItemCodeEditor(e);
        else if (e.dataField === EDITABLE_FIELD.WEIGHT)
            this.prepareWeightEditor(e);
    }
    // Weight: the lot's weight (legacy Lot grid WeightQuantity), never negative (cdsLotListWeightQuantityValidate);
    // 0 or blank means none.
    prepareWeightEditor(e) {
        e.editorOptions.min = 0;
        e.editorOptions.onValueChanged = (args) => {
            const weight = Number(args.value) || 0;
            this.setWeight(e.row.data.rlot, weight > 0 ? weight : null);
        };
    }
    // Item Code: the code the receipt customer gets the row's item as - one of its items in the receiving facility, or
    // a typed code (legacy AsItemCode lookup, an edit list); one per source item, so it applies to all of the item's
    // lots/sublots. Blank keeps the source item's code, shown as placeholder.
    prepareReceivingItemCodeEditor(e) {
        const current = e.value;
        const items = current && !this.receivingItems.some(item => item.name === current)
            ? [{ name: current, description: "" }, ...this.receivingItems]
            : this.receivingItems;
        e.editorName = 'dxSelectBox';
        e.editorOptions.dataSource = items;
        e.editorOptions.valueExpr = 'name';
        e.editorOptions.displayExpr = 'name';
        e.editorOptions.searchEnabled = true;
        e.editorOptions.searchExpr = ['name', 'description'];
        e.editorOptions.acceptCustomValue = true;
        e.editorOptions.showClearButton = true;
        e.editorOptions.maxLength = ITEM_CODE_MAX_LENGTH;
        e.editorOptions.placeholder = e.row.data.itemcode;
        e.editorOptions.itemTemplate = (item) => {
            const element = document.createElement('div');
            element.textContent = item.description ? `${item.name} - ${item.description}` : item.name;
            return element;
        };
        e.editorOptions.onCustomItemCreating = (args) => {
            const name = (args.text || "").trim();
            args.customItem = name ? { name, description: "" } : null;
        };
        e.editorOptions.onValueChanged = (args) => this.setReceivingItemCode(e.row.data.ritem, args.value);
    }
    // Quantity is capped at the row's available quantity (legacy cdsTransferValidate).
    prepareQuantityEditor(e) {
        const available = e.row?.data?.transferavailable || 0;
        e.editorOptions.min = 0;
        e.editorOptions.max = available;
        e.editorOptions.onValueChanged = (args) => {
            const rowKey = e.row.key;
            let quantity = Number(args.value) || 0;
            if (quantity > available) {
                notify({ message: MESSAGES.TRANSFER_QTY_EXCEEDS_AVAILABLE, width: 450 }, 'warning', 3000);
                quantity = available;
            }
            if (quantity < 0)
                quantity = 0;
            this.setState((prevState) => {
                const quantities = this.selectionQuantities(prevState.inventorySelection);
                quantities.set(rowKey, quantity);
                return { inventorySelection: this.buildSelection(prevState.inventorySelection, quantities) };
            });
        };
    }
    // Ticking a row transfers all of its available quantity, unticking clears it (legacy cxGridViewEditing).
    // Both tabs' grids report here; one grid catching up with a change the other made changes nothing.
    DetailGridselectionChanged({ currentSelectedRowKeys, currentDeselectedRowKeys }) {
        if (!(currentSelectedRowKeys?.length) && !(currentDeselectedRowKeys?.length))
            return;
        this.setState(prevState => {
            const quantities = this.selectionQuantities(prevState.inventorySelection);
            const rowsByKey = new Map(prevState.inventorySelection.itemGridArr.map(row => [row.key, row]));
            let changed = false;
            (currentDeselectedRowKeys || []).forEach(key => {
                changed = quantities.delete(key) || changed;
            });
            (currentSelectedRowKeys || []).forEach(key => {
                if (!quantities.get(key)) {
                    quantities.set(key, rowsByKey.get(key)?.transferavailable || 0);
                    changed = true;
                }
            });
            if (!changed)
                return null;
            return { inventorySelection: this.buildSelection(prevState.inventorySelection, quantities) };
        });
    }
    componentDidMount() {
        window.addEventListener("beforeunload", this.onBeforeUnload);
        this.LoadShipmentDropDowns();
    }
    componentDidUpdate(prevProps, prevState) {
        // redux-oidc renews the user silently and hands the new one down as props; the module-level token and oidc
        // were captured once in the constructor, so every request after a renewal carried the expired token.
        if (this.props.oidc !== prevProps.oidc && this.props.oidc?.user) {
            oidc = this.props.oidc;
            accessToken = this.props.oidc.user.access_token;
        }
        const { customerId, dbid } = this.state.receipt;
        if (customerId !== prevState.receipt.customerId || String(dbid) !== String(prevState.receipt.dbid))
            this.LoadReceivingItems();
    }
    // Only the latest load may fill the list: an earlier one finishing late would offer another customer's items.
    LoadReceivingItems() {
        const loadId = ++this.receivingItemsLoadId;
        const { customerId, dbid } = this.state.receipt;
        this.receivingItems = [];
        if (!customerId)
            return;
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetReceivingItems}?customerId=${customerId}&userDBId=${dbid || ""}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (loadId === this.receivingItemsLoadId)
                this.receivingItems = response.data || [];
        }).catch(() => notify({ message: MESSAGES.OWNERSHIP_TRANSFER_LOAD_FAILED, width: 450 }, 'error', 2000));
    }
    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
    }
    // Legacy FormCloseQuery: leaving after a profile was picked but before Apply asks first.
    isTransferPending() {
        return !!this.state.shipment.profileId && !this.state.appliedResult;
    }
    onBeforeUnload = (e) => {
        if (!this.isTransferPending())
            return;
        e.preventDefault();
        e.returnValue = MESSAGES.OWNERSHIP_TRANSFER_NOT_APPLIED_EXIT;
    }
    LoadShipmentDropDowns() {
        this.setState({
            loadIndicatorVisible: true
        });
        Promise.all([
            this.LoadCustomerList('', '', '', false),
            this.LoadShipperList('', '', '', false),
            this.LoadConsigneeList('', '', '', false),
            this.LoadRateSchduleList('', '', '', false),
            this.LoadUserDefinedCodes('shipment', ''),
        ]).then(() => {
            return this.LoadShipmentProfiles();
        }).catch((err) => {
            this.setState({
                loadIndicatorVisible: false
            });
            notify({
                message: MESSAGES.OWNERSHIP_TRANSFER_LOAD_FAILED,
                width: 450,
            }, 'error', 2000);
        });
    }
    LoadShipmentProfiles() {
        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfiles}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.status == 200) {
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        shipment: {
                            ...prevState.shipment,
                            arrShipmentProfile: response.data,
                        },
                    }));
                }
                else {
                    notify({
                        message: MESSAGES.OWNERSHIP_TRANSFER_PROFILES_LOAD_FAILED,
                        width: 450,
                    }, 'error', 2000);
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        shipment: {
                            ...prevState.shipment,
                            arrShipmentProfile: [],
                        },
                    }));
                }
            })
            .catch(() => {
                // A failed request (network, 4xx/5xx) never reaches the status check above; without this the loader
                // stayed up for good.
                notify({
                    message: MESSAGES.OWNERSHIP_TRANSFER_PROFILES_LOAD_FAILED,
                    width: 450,
                }, 'error', 2000);
                this.setState(prevState => ({
                    loadIndicatorVisible: false,
                    shipment: {
                        ...prevState.shipment,
                        arrShipmentProfile: [],
                    },
                }));
            });
    }
    LoadDatabasesAndCompanyIds(selectedDatabaseValue, isRerenderNeeded = true) {
        if (oidc.user.profile.webUserInfo) {
            // Only the latest facility load may fill the receipt lookups or reset the receipt: an earlier
            // load finishing late would leave one facility's profiles and customers under another's id.
            const loadId = ++this.receiptFacilityLoadId;
            const isCurrent = () => loadId === this.receiptFacilityLoadId;
            let webUserInfo = JSON.parse(oidc.user.profile.webUserInfo);
            this.setState({
                loadIndicatorVisible: true
            });
            axios.get(
                `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetDatabasesAndCompanies}?userId=${oidc.user.profile.sub}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            )
                .then(async (res) => {
                    if (!isCurrent())
                        return;
                    var dta = res.data.companies;
                    const selectedRecord = (selectedDatabaseValue != null && selectedDatabaseValue != undefined && selectedDatabaseValue != '') ?
                        dta.find(item => item.value == selectedDatabaseValue) :
                        dta.find(item => item.value == webUserInfo.userCompanyId);
                    const uniqueTexts = new Set(selectedRecord ? [selectedRecord.text] : []);
                    const remainingUniqueArray = dta
                        .filter(item => item.value !== (
                            (selectedDatabaseValue != null && selectedDatabaseValue != undefined && selectedDatabaseValue != '') ?
                                selectedDatabaseValue :
                                webUserInfo.userCompanyId) && !uniqueTexts.has(item.text))
                        .filter(item => {
                            if (!uniqueTexts.has(item.text)) {
                                uniqueTexts.add(item.text);
                                return true;
                            }
                            return false;
                        });
                    const resultArr = await this.fetchData();
                    if (!isCurrent())
                        return;
                    const filteredCompanyIds = dta
                        .filter(item => item.text == selectedRecord.text)
                        .map(item => ({
                            ...item,
                            id: item.companyname,
                            name: item.companyname
                        }));
                    if (isRerenderNeeded) {
                        let identityDataStore = new DataSource({
                            store: new ArrayStore({
                                data: resultArr
                            }),
                            paginate: true,
                            pageSize: 100
                        });
                        receiptDatabaseSelectBox.current.instance().option(
                            "dataSource",
                            identityDataStore
                        );
                        receiptDatabaseSelectBox.current.instance().option(
                            "acceptCustomValue",
                            false
                        );
                    }
                    // Returned, so the outer finally (which hides the loader) runs after the lookups, not before.
                    return Promise.all([
                        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfiles}?dbName=${selectedRecord.text}&companyid=${selectedRecord.companyname}&userDBId=${selectedRecord.value}`,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        )
                            .then((response) => {
                                if (!isCurrent())
                                    return;
                                let identityDataStore = new DataSource({
                                    store: new ArrayStore({
                                        data: response.data
                                    }),
                                    paginate: true,
                                    pageSize: 100
                                });
                                receiptProfileSelectBox.current.instance().option(
                                    "dataSource",
                                    identityDataStore
                                );
                                receiptProfileSelectBox.current.instance().option(
                                    "acceptCustomValue",
                                    false
                                );
                            }),
                        this.LoadCustomerList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true, isCurrent),//selectedRecord.value is id column of UserCompanies table
                        this.LoadShipperList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true, isCurrent),
                        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetItemProfiles}?dbName=${selectedRecord.text}&companyid=${selectedRecord.companyname}&userDBId=${selectedRecord.value}`,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        ).then((response) => {
                            if (!isCurrent())
                                return;
                            let identityDataStore = new DataSource({
                                store: new ArrayStore({
                                    data: response.data
                                }),
                                paginate: true,
                                pageSize: 100
                            });
                            receiptItemProfileSelectBox.current.instance().option(
                                "dataSource",
                                identityDataStore
                            );
                            receiptItemProfileSelectBox.current.instance().option(
                                "acceptCustomValue",
                                false
                            );
                        }),
                        this.LoadRateSchduleList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true, isCurrent),
                        this.LoadConsigneeList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true, isCurrent),
                        this.LoadUserDefinedCodes('receipt', selectedRecord.value, isCurrent),
                        this.LoadWarehouseList(selectedRecord.value, isCurrent)
                    ]).then(() => {
                        if (!isCurrent())
                            return;
                        this.setState((prevState) => ({
                            loadIndicatorVisible: false,
                            receipt: {
                                ...prevState.receipt,
                                databaseId: isRerenderNeeded ? selectedRecord.value : prevState.receipt.databaseId,
                                companyId: selectedRecord?.companyname,
                                dbid: selectedRecord?.value,
                                profileId: "",
                                customerId: "",
                                transDate: new Date(),
                                transactionNo: "",
                                shipperId: "",
                                consigneeId: "",
                                stage: "P",
                                status: "O",
                                shipperBolNo: "",
                                poReference: "",
                                rateScheduleId: "",
                                transGroup: "",
                                comment: "",
                                ...emptyUserDefinedFields(),
                                recvDate: new Date(),
                                itemProfileId: "",
                                transferUnspecifiedSerialNumbers: false,
                                defaultWarehouseId: "",
                                defaultLocationId: "",
                                receiptDisabled: true
                            }
                        }));
                    }).catch((err) => {
                        if (!isCurrent())
                            return;
                        this.setState({
                            loadIndicatorVisible: false
                        });
                        notify({
                            message: MESSAGES.OWNERSHIP_TRANSFER_LOAD_FAILED,
                            width: 450,
                        }, 'error', 2000);
                    });
                })
                .catch((err) => {
                    console.log(err, "error while gettng databases");
                    this.setState({
                        loadIndicatorVisible: false
                    });
                }).finally(() => {
                    // A newer facility load owns the loader; only the current one may hide it.
                    if (isCurrent())
                        this.setState({ loadIndicatorVisible: false });
                });
        }
    }
    setSelectBoxItems(selectBox, data) {
        if (!selectBox.current)
            return;
        selectBox.current.instance().option("dataSource", new DataSource({
            store: new ArrayStore({ data: data || [] }),
            paginate: true,
            pageSize: 100
        }));
        selectBox.current.instance().option("acceptCustomValue", false);
    }
    // Warehouses of the receiving facility, for the default receiving location used when a source
    // location code has no match there.
    LoadWarehouseList(dbid, isCurrent = () => true) {
        this.setSelectBoxItems(receiptLocationSelectBox, []);
        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWarehouseList}?userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (isCurrent())
                this.setSelectBoxItems(receiptWarehouseSelectBox, response.data);
        });
    }
    ReceiptWarehouseChanged(e) {
        this.setState(prvState => ({
            receipt: {
                ...prvState.receipt,
                defaultWarehouseId: e.value || "",
                defaultLocationId: ""
            }
        }));
        this.setSelectBoxItems(receiptLocationSelectBox, []);
        if (!e.value)
            return;
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetLocationList}?warehouseId=${e.value}&userDBId=${this.state.receipt.dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => this.setSelectBoxItems(receiptLocationSelectBox, response.data))
            .catch(() => notify({ message: MESSAGES.OWNERSHIP_TRANSFER_LOAD_FAILED, width: 450 }, 'error', 2000));
    }
    // The codes for a side's User Defined Code 1-10 fields, read in that side's facility (dbid blank = signed in).
    LoadUserDefinedCodes(side, dbid, isCurrent = () => true) {
        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetUserDefinedCodes}?userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (!isCurrent())
                return;
            this.setState(prevState => ({
                userDefinedCodeOptions: { ...prevState.userDefinedCodeOptions, [side]: userDefinedCodeOptions(response.data) }
            }));
        });
    }
    UserDefinedChanged(side, kind, index, value) {
        this.setState(prevState => {
            const values = [...prevState[side][kind]];
            values[index] = value;
            return { [side]: { ...prevState[side], [kind]: values } };
        });
    }
    LoadRateSchduleList(databaseid, companyId, dbid, isReceipt, isCurrent = () => true) {
        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetRateSchduleList}?dbName=${databaseid}&companyid=${companyId}&userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (!isCurrent())
                return;
            let identityDataStore = new DataSource({
                store: new ArrayStore({
                    data: response.data
                }),
                paginate: true,
                pageSize: 100
            });
            if (isReceipt) {
                receiptRateSchdSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                receiptRateSchdSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            else {
                shipmentRateSchdSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentRateSchdSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
        })

    }
    LoadConsigneeList(databaseid, companyId, dbid, isReceipt, isCurrent = () => true) {
        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetConsigneeList}?dbName=${databaseid}&companyid=${companyId}&userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (!isCurrent())
                return;
            if (isReceipt) {
                this.setSelectBoxItems(receiptConsigneeSelectBox, response.data);
            }
            else {
                // Kept for the consignee cross-fill: a receipt customer that is also a consignee here
                // becomes the shipment's consignee.
                this.shipmentConsigneeIds = new Set((response.data || []).map(row => row.id));
                this.setSelectBoxItems(shipmentConsigneeSelectBox, response.data);
            }
        });
    }
    LoadShipperList(databaseid, companyId, dbid, isReceipt, isCurrent = () => true) {

        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetShipperList}?dbName=${databaseid}&companyid=${companyId}&userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (!isCurrent())
                return;
            let identityDataStore = new DataSource({
                store: new ArrayStore({
                    data: response.data
                }),
                paginate: true,
                pageSize: 100
            });
            if (isReceipt) {
                // Kept for the shipper cross-fill: a shipment customer that is also a shipper in the receiving
                // facility becomes the receipt's shipper.
                this.receiptShipperIds = new Set((response.data || []).map(row => row.id));
                receiptShipperSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                receiptShipperSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            else {
                shipmentShipperSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentShipperSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
        });
    }
    LoadCustomerList(databaseid, companyId, userCompanyId, isReceipt, isCurrent = () => true) {
        let url=isReceipt?`${routes.OwnerShipTransfer.GetCustomersList}?dbName=${databaseid}&companyId=${companyId}&userCompanyId=${userCompanyId}` : `${routes.OwnerShipTransfer.GetCustomersList}`
        return axios.get(`${window._env_.REACT_APP_APIS}/${url}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            if (!isCurrent())
                return;
            let identityDataStore = new DataSource({
                store: new ArrayStore({
                    data: response.data
                }),
                paginate: true,
                pageSize: 100
            });
            if (isReceipt) {
                receiptCustomerSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                receiptCustomerSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            else {

                shipmentCustomerSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentCustomerSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
        });
    }
    onInventoryTabSelectionChanged = (e) => {
        this.setState({ inventoryTabIndex: e.component.option("selectedIndex") });
    }
    onTabSelectionChanged(e) {
        const newIndex = e.component.option("selectedIndex");
        this.setState({ selectedTabIndex: newIndex });
        if (newIndex == 1 && !this.state.isReceiptTabLoaded) {
            this.setState({
                isReceiptTabLoaded: true
            });
            this.LoadDatabasesAndCompanyIds();
        }
        else if (newIndex == 2 && !this.state.isInventoryTabLoaded) {
            this.setState({
                isInventoryTabLoaded: true
            });
            this.LoadItemsGrid();
        }
    }
    LoadItemsGrid() {
        this.setState(prevState => ({
            loadIndicatorVisible: true,
        }));
        let Itemcodefrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodefrom;
        let Itemcodeto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodeto;
        let Itemdescfrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescfrom;
        let Itemdescto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescto;
        let Lotcodefrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodefrom;
        let Lotcodeto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodeto;
        let Lotdescfrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescfrom;
        let Lotdescto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescto;
        let Customerid = this.state.shipment.customerId;
        let request = {
            Itemcodefrom: Itemcodefrom,
            Itemcodeto: Itemcodeto,
            Itemdescfrom: Itemdescfrom,
            Itemdescto: Itemdescto,
            Lotcodefrom: Lotcodefrom,
            Lotcodeto: Lotcodeto,
            Lotdescfrom: Lotdescfrom,
            Lotdescto: Lotdescto,
            Rcustomerid: Customerid,
        }
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.LoadOTItemDetailGrid}`, request,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let rslt = response.data || [];
                if (rslt.length === 0) {
                    const filtered = Object.values(this.state.inventorySelection.ItemsGridDataFilterCriteria).some(value => value);
                    notify({
                        message: filtered ? MESSAGES.OWNERSHIP_TRANSFER_FILTER_NO_ITEMS : MESSAGES.OWNERSHIP_TRANSFER_CUSTOMER_NO_ITEMS,
                        width: 450,
                    }, 'warning', 3000);
                }
                // Rows already given a quantity stay selected under a new filter (legacy ClearNotSelected):
                // keep the ones the new result no longer contains, and re-apply every kept quantity.
                this.setState((prevState) => {
                    const loadedKeys = new Set(rslt.map(row => row.key));
                    const quantities = this.selectionQuantities(prevState.inventorySelection);
                    const keptRows = prevState.inventorySelection.itemGridArr
                        .filter(row => quantities.get(row.key) > 0 && !loadedKeys.has(row.key));
                    return {
                        loadIndicatorVisible: false,
                        inventorySelection: this.buildSelection({
                            ...prevState.inventorySelection,
                            itemGridArr: [...keptRows, ...rslt]
                        }, quantities),
                    };
                });
            }).catch((err) => {
                this.setState({
                    loadIndicatorVisible: false
                });
                console.log(err, "Error in loading grid items");
            });
    }
    onApplyClick() {
        // Apply is one transfer: a second click while the first is still validating, confirming or inserting must
        // not send another. An instance flag, because setState is not applied before the next click handler runs.
        if (this.isApplying)
            return;
        if (this.state.shipment.profileId &&
            this.state.shipment.customerId &&
            this.state.shipment.stage &&
            this.state.shipment.status &&
            this.state.shipment.shipDate &&
            this.state.receipt.databaseId &&
            this.state.receipt.companyId &&
            this.state.receipt.customerId &&
            this.state.receipt.profileId &&
            this.state.receipt.stage &&
            this.state.receipt.status &&
            this.state.receipt.recvDate &&
            this.state.receipt.dbid) {
            // Copies with formatted dates: the screen's own state is not modified by the request.
            const request = {
                receipt: {
                    ...this.state.receipt,
                    transDate: GetFormatedDateWithTime(this.state.receipt.transDate),
                    recvDate: GetFormatedDateWithTime(this.state.receipt.recvDate),
                    ...userDefinedFieldsForRequest(this.state.receipt),
                },
                shipment: {
                    ...this.state.shipment,
                    transDate: GetFormatedDateWithTime(this.state.shipment.transDate),
                    shipDate: GetFormatedDateWithTime(this.state.shipment.shipDate),
                    ...userDefinedFieldsForRequest(this.state.shipment),
                },
                inventoryselection: {
                    Selectedrowkeys: this.state.inventorySelection.selectedRowKeys,
                    Selectedrowdata: this.state.inventorySelection.selectedgriditems
                }
            };
            const options = {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            };

            this.isApplying = true;
            this.setState({ loadIndicatorVisible: true, applying: true });
            // Evaluate first: errors refuse, warnings (credit review/COD, Stage Completed) need a Yes.
            axios.post(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.ValidateOwnershipTransferInternal}`, request, options)
                .then((res) => {
                    const evaluation = res.data || {};
                    if (!evaluation.success) {
                        this.setState({ loadIndicatorVisible: false });
                        alert(evaluation.message || MESSAGES.ERROR, MESSAGES.ERROR);
                        return null;
                    }
                    if (!evaluation.warnings?.length)
                        return true;
                    this.setState({ loadIndicatorVisible: false });
                    return confirm(evaluation.warnings.join(MESSAGE_SEPARATOR + MESSAGE_SEPARATOR), MESSAGES.WARNING);
                })
                .then((proceed) => {
                    if (!proceed)
                        return null;
                    this.setState({ loadIndicatorVisible: true });
                    return axios.post(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.InsertOwnershiptransferInternal}`, request, options)
                        .then((res) => {
                            this.setState({ loadIndicatorVisible: false });
                            notify({ message: res.data.message, width: 450 }, 'success', 8000);
                            this.showAppliedResult(res.data);
                        });
                })
                .catch((err) => {
                    this.setState({ loadIndicatorVisible: false });
                    if (err?.[CONCURRENCY_HANDLED])
                        return;
                    alert(getApiErrorMessage(err, MESSAGES.ERROR), MESSAGES.ERROR);
                })
                .finally(() => {
                    this.isApplying = false;
                    this.setState({ applying: false });
                });
        }
        else {
            notify({
                message: MESSAGES.OWNERSHIP_TRANSFER_REQUIRED_FIELDS,
                width: 450,
            }, 'error', 2000);
        }
    }
    // Legacy reloads both created headers read-only and offers Add; here the screen locks, the created
    // numbers fill the Transaction # fields, and Reset starts the next transfer.
    showAppliedResult(result) {
        this.setState(prevState => ({
            appliedResult: result,
            shipment: { ...prevState.shipment, transactionNo: result.shipmentTransactionNumber, shipmentDisabled: true },
            receipt: { ...prevState.receipt, transactionNo: result.receiptTransactionNumber, receiptDisabled: true },
        }));
    }
    appliedMessage() {
        const result = this.state.appliedResult;
        return MESSAGES.OWNERSHIP_TRANSFER_APPLIED
            .replace('{0}', result.shipmentTransactionNumber)
            .replace('{1}', result.shipmentFacility)
            .replace('{2}', result.receiptTransactionNumber)
            .replace('{3}', result.receiptFacility);
    }
    // Legacy ClearSelection: every entered transfer quantity is dropped after a confirm.
    ClearSelection = (e) => {
        e.event.stopPropagation();
        confirm(MESSAGES.OWNERSHIP_TRANSFER_CLEAR_SELECTION, MESSAGES.WARNING).then((yes) => {
            if (!yes)
                return;
            this.setState(prevState => ({
                inventorySelection: this.buildSelection(prevState.inventorySelection, new Map())
            }));
        });
    }
    onShipmentClickNext() {
        if (this.state.shipment.profileId) {
            this.setState((prevState) => ({
                ...prevState,
                selectedTabIndex: prevState.selectedTabIndex < 2 ? prevState.selectedTabIndex + 1 : prevState.selectedTabIndex
            }));
            if (this.state.selectedTabIndex == 1 && !this.state.isReceiptTabLoaded) {
                this.setState((prevState) => ({
                    ...prevState,
                    isReceiptTabLoaded: true
                }));
                this.LoadDatabasesAndCompanyIds();
            }
        }
        else {
            notify({
                message: MESSAGES.OWNERSHIP_TRANSFER_SELECT_PROFILE,
                width: 450,
            }, 'error', 2000);
        }
    }
    onReceiptClickNext() {
        if (this.state.shipment.profileId &&
            this.state.shipment.customerId &&
            this.state.receipt.databaseId &&
            this.state.receipt.companyId &&
            this.state.receipt.profileId) {
            this.setState((prevState) => ({
                ...prevState,
                selectedTabIndex: prevState.selectedTabIndex < 2 ? prevState.selectedTabIndex + 1 : prevState.selectedTabIndex
            }));
            if (this.state.selectedTabIndex == 2 && !this.state.isInventoryTabLoaded) {
                this.setState({
                    isInventoryTabLoaded: true
                });
                this.LoadItemsGrid();
            }
        }
        else {
            notify({
                message: MESSAGES.OWNERSHIP_TRANSFER_SELECT_TAB_VALUES,
                width: 450,
            }, 'error', 4000);
        }
    }
    updateFilterCriteria = (field, value) => {
        this.setState(prevState => ({
            inventorySelection: {
                ...prevState.inventorySelection,
                ItemsGridDataFilterCriteria: {
                    ...prevState.inventorySelection.ItemsGridDataFilterCriteria,
                    [field]: value
                }
            }
        }));
    }
    // The selection belongs to the previous customer's inventory, so it is dropped with the grid.
    ShipmentCustomerChanged(e) {
        this.setState(prvState => ({
            isInventoryTabLoaded: false,
            shipment: {
                ...prvState.shipment,
                customerId: e.value
            },
            receipt: {
                ...prvState.receipt,
                shipperId: this.receiptShipperFor(e.value, prvState.receipt.shipperId)
            },
            inventorySelection: {
                ...prvState.inventorySelection,
                detailTransferQuantityCount: 0,
                selectedRowKeys: [],
                itemGridArr: [],
                selectedGridArr: [],
                selectedgriditems: [],
            }
        }));
    }
    ShipmentProfileChanged(e) {
        var rowid = e?.selectedItem?.id;
        if (!rowid)
            return;
        this.setState(prevState => ({
            loadIndicatorVisible: true,
            shipment: {
                ...prevState.shipment,
                profileId: rowid
            }
        }));
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfilesSettings}?profilerowid=${rowid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((res) => {
                // Defaults of a profile the user has since replaced must not land on the newer one.
                if (String(this.state.shipment.profileId) !== String(rowid))
                    return;
                if (res.data.success) {
                    var rsltDta = res.data.resultdata;
                    this.setState(prvState => ({
                        ...prvState,
                        isTabDisabled: false,
                        shipment: {
                            ...prvState.shipment,
                            profileId: prvState.shipment.profileId,
                            customerId: rsltDta?.rCustomer,
                            transDate: rsltDta?.transactiondate || new Date(),
                            transactionNo: rsltDta?.transactionnumber,
                            shipperId: rsltDta?.rShipper,
                            consigneeId: this.shipmentConsigneeFor(prvState.receipt.customerId, rsltDta?.rConsignee),
                            stage: rsltDta?.stage || STAGE_READY,
                            status: rsltDta?.status || STATUS_OPEN,
                            shipperBolNo: rsltDta?.shipperbolnumber,
                            poReference: rsltDta?.reference,
                            rateScheduleId: rsltDta?.rRateschedule,
                            transGroup: rsltDta?.transactiongroup,
                            comment: rsltDta?.comment,
                            ...userDefinedFieldsFromProfile(rsltDta),
                            shipDate: rsltDta?.actualreceivedshippeddatetime || new Date(),
                            shipmentDisabled: false,
                        }
                    }));
                }
            })
            .catch((err) => {
                console.log(err, "Error in loading Profile");
            }).finally(() => {
                this.setState({
                    loadIndicatorVisible: false
                });
            });
    }
    ReceiptProfileChanged(e) {
        var rowid = e.value;
        // A cleared profile - by the user, or by a facility change resetting the receipt - has no defaults to read.
        // Asking the server for an empty profile would return nothing and overwrite the form with blanks.
        if (!rowid) {
            this.setState(prevState => ({
                receipt: {
                    ...prevState.receipt,
                    profileId: ""
                }
            }));
            return;
        }
        const facility = this.state.receipt.dbid;
        this.setState((prevState) => ({
            ...prevState,
            loadIndicatorVisible: true,
            receipt: {
                ...prevState.receipt,
                profileId: e.value
            }
        }));
        // userDBId makes the server read the profile defaults in the receiving facility, not the signed-in one.
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfilesSettings}?profilerowid=${rowid}&dbName=${this.state.receipt.databaseId}&companyid=${this.state.receipt.companyId}&userDBId=${this.state.receipt.dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((res) => {
                // Defaults read for a facility the user has since left must not land on the new one.
                if (String(this.state.receipt.dbid) !== String(facility))
                    return;
                // Likewise defaults of a profile the user has since replaced or cleared.
                if (String(this.state.receipt.profileId) !== String(rowid))
                    return;
                if (res.data.success) {
                    var rsltDta = res.data.resultdata;
                    this.setState(prvState => ({
                        ...prvState,
                        receipt: {
                            ...prvState.receipt,
                            databaseId: prvState.receipt.databaseId,
                            companyId: prvState.receipt.companyId,
                            profileId: prvState.receipt.profileId,
                            customerId: rsltDta?.rCustomer,
                            transDate: rsltDta?.transactiondate || new Date(),
                            transactionNo: rsltDta?.transactionnumber,
                            shipperId: this.receiptShipperFor(prvState.shipment.customerId, rsltDta?.rShipper),
                            consigneeId: rsltDta?.rConsignee,
                            stage: rsltDta?.stage || STAGE_READY,
                            status: rsltDta?.status || STATUS_OPEN,
                            shipperBolNo: rsltDta?.shipperbolnumber,
                            poReference: rsltDta?.reference,
                            rateScheduleId: rsltDta?.rRateschedule,
                            transGroup: rsltDta?.transactiongroup,
                            comment: rsltDta?.comment,
                            ...userDefinedFieldsFromProfile(rsltDta),
                            recvDate: rsltDta?.actualreceivedshippeddatetime || prvState.shipment.shipDate || new Date(),
                            receiptDisabled: false,
                            transferUnspecifiedSerialNumbers: false
                        }
                    }));
                }
            })
            .catch((err) => {
                console.log(err, "Error in loading Profile");
            }).finally(() => {
                this.setState({
                    loadIndicatorVisible: false
                });
            });
    }
    AccordionSelectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        this.setState((prevState) => ({
            selectedItems: newItems,
            searchPanelStatus: !prevState.searchPanelStatus,
        }));
    }
    fetchData = async () => {
        try {
            if (oidc.user.profile.webUserInfo) {
                const res = await axios.get(
                    `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetDatabasesCompanies}?userId=${oidc.user.profile.sub}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        }
                    }
                );
                if (res.data && res.data.companies.length > 0) {
                    return res.data.companies;

                } else {
                    console.warn("No companies data available.");
                    return null;
                }
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
    };
    // The Select Inventory tabs' leading editable columns: legacy Transfer (Quantity) and AsItemCode (Item Code, on the
    // Item grid), which only the Selected Inventory tab shows. Selected is the grids' checkbox; legacy's other editable
    // column, Weight (on the Lot grid), sits after Sublot as Lot Weight.
    editableColumns({ withItemCode = false } = {}) {
        return [
            <Column key={EDITABLE_FIELD.QUANTITY} dataField={EDITABLE_FIELD.QUANTITY} dataType="number" caption="Quantity"></Column>,
            withItemCode && <Column key={EDITABLE_FIELD.ITEM_CODE} dataField={EDITABLE_FIELD.ITEM_CODE} caption="Item Code"></Column>,
        ].filter(Boolean);
    }
    // The inventory columns both Select Inventory tabs show after their leading editable ones - read-only but for Lot
    // Weight - then, hidden for the column chooser, the rest of the legacy Item/Lot/SubLot/Location grids' columns.
    // The location ones, like Warehouse/Location, are filled only when the row's stock sits in one location.
    inventoryColumns() {
        return [
            <Column key="itemcode" dataField="itemcode" caption="Item" allowEditing={false}></Column>,
            <Column key="warehousecode" dataField="warehousecode" caption="Warehouse" allowEditing={false}></Column>,
            <Column
                key="locationcode"
                dataField="locationcode"
                caption="Location"
                allowEditing={false}
                calculateCellValue={(row) => row.locationcount > 1 ? MESSAGES.OWNERSHIP_TRANSFER_MULTIPLE_LOCATIONS : row.locationcode}
            ></Column>,
            <Column key="transferavailable" dataField="transferavailable" caption="Available" dataType="number" allowEditing={false}></Column>,
            <Column key="itemdescription" dataField="itemdescription" caption="Item Description" allowEditing={false} visible={false}></Column>,
            <Column key="lotcode" dataField="lotcode" caption="Lot" allowEditing={false}></Column>,
            <Column key="lotdescription" dataField="lotdescription" caption="Lot Description" allowEditing={false} visible={false}></Column>,
            <Column key="sublotcode" dataField="sublotcode" caption="Sublot" allowEditing={false}></Column>,
            <Column key={EDITABLE_FIELD.WEIGHT} dataField={EDITABLE_FIELD.WEIGHT} dataType="number" caption="Lot Weight"></Column>,
            <Column key="sublotdescription" dataField="sublotdescription" caption="Sublot Description" allowEditing={false} visible={false}></Column>,
            <Column key="alternateid" dataField="alternateid" caption="Alternate ID" allowEditing={false} visible={false}></Column>,
            <Column key="netweight" dataField="netweight" caption="Net Wt" dataType="number" allowEditing={false}></Column>,
            <Column key="grossweight" dataField="grossweight" caption="Gross Wt" dataType="number" allowEditing={false}></Column>,
            <Column key="itemtype" dataField="itemtype" caption="Item Type" allowEditing={false} visible={false}>
                <Lookup dataSource={ItemTypeFlag} valueExpr="key" displayExpr="value" />
            </Column>,
            <Column key="classcode" dataField="classcode" caption="Item Class" allowEditing={false} visible={false}></Column>,
            <Column key="palletsizecode" dataField="palletsizecode" caption="PalletSizeCode" allowEditing={false} visible={false}></Column>,
            <Column key="subclasscode" dataField="subclasscode" caption="Item SubClass" allowEditing={false} visible={false}></Column>,
            <Column key="netavailable" dataField="netavailable" caption="Item Net Avl" allowEditing={false}></Column>,
            <Column key="lotnetavailable" dataField="lotnetavailable" caption="Lot Net Avl" allowEditing={false}></Column>,
            <Column
                key="balance"
                name="balance"
                caption="Balance"
                dataType="number"
                allowEditing={false}
                visible={false}
                calculateCellValue={(row) => (row.transferavailable || 0) - (row.quantityorder || 0)}
            ></Column>,
            <Column key="itemDescription2" dataField="itemDescription2" caption="Item Description 2" allowEditing={false} visible={false}></Column>,
            <Column key="itemOnHand" dataField="itemOnHand" caption="Item On Hand" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="available" dataField="available" caption="Item Available" dataType="number" allowEditing={false} visible={false}></Column>,
            statusColumn("itemStatus", "Item Status"),
            <Column key="itemDateIntroduced" dataField="itemDateIntroduced" caption="Item Date Introduced" dataType="date" allowEditing={false} visible={false}></Column>,
            <Column key="itemDateAvailable" dataField="itemDateAvailable" caption="Item Date Available" dataType="date" allowEditing={false} visible={false}></Column>,
            ...userDefinedColumns("itemUserDefined", "Item"),
            <Column key="lotDescription2" dataField="lotDescription2" caption="Lot Description 2" allowEditing={false} visible={false}></Column>,
            <Column key="lotOnHand" dataField="lotOnHand" caption="Lot On Hand" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="lotavailable" dataField="lotavailable" caption="Lot Available" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="lotClassCode" dataField="lotClassCode" caption="Lot Class" allowEditing={false} visible={false}></Column>,
            <Column key="lotSubClassCode" dataField="lotSubClassCode" caption="Lot SubClass" allowEditing={false} visible={false}></Column>,
            statusColumn("lotStatus", "Lot Status"),
            <Column key="lotDateIntroduced" dataField="lotDateIntroduced" caption="Lot Date Introduced" dataType="date" allowEditing={false} visible={false}></Column>,
            <Column key="lotDateAvailable" dataField="lotDateAvailable" caption="Lot Date Available" dataType="date" allowEditing={false} visible={false}></Column>,
            <Column key="lotNetWeightQuantity" dataField="lotNetWeightQuantity" caption="Lot Net Wt" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="lotGrossWeightQuantity" dataField="lotGrossWeightQuantity" caption="Lot Gross Wt" dataType="number" allowEditing={false} visible={false}></Column>,
            ...userDefinedColumns("lotUserDefined", "Lot"),
            <Column key="sublotDescription2" dataField="sublotDescription2" caption="Sublot Description 2" allowEditing={false} visible={false}></Column>,
            <Column key="sublotOnHand" dataField="sublotOnHand" caption="Sublot On Hand" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="sublotavailable" dataField="sublotavailable" caption="Sublot Available" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="sublotnetavailable" dataField="sublotnetavailable" caption="Sublot Net Avl" dataType="number" allowEditing={false} visible={false}></Column>,
            statusColumn("sublotStatus", "Sublot Status"),
            <Column key="sublotDateIntroduced" dataField="sublotDateIntroduced" caption="Sublot Date Introduced" dataType="date" allowEditing={false} visible={false}></Column>,
            <Column key="sublotDateAvailable" dataField="sublotDateAvailable" caption="Sublot Date Available" dataType="date" allowEditing={false} visible={false}></Column>,
            ...userDefinedColumns("sublotUserDefined", "Sublot"),
            <Column key="locationDescription" dataField="locationDescription" caption="Location Description" allowEditing={false} visible={false}></Column>,
            <Column key="locationOnHand" dataField="locationOnHand" caption="Location On Hand" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="locationAvailable" dataField="locationAvailable" caption="Location Available" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="locationNetAvailable" dataField="locationNetAvailable" caption="Location Net Avl" dataType="number" allowEditing={false} visible={false}></Column>,
            <Column key="locationClassCode" dataField="locationClassCode" caption="Location Class" allowEditing={false} visible={false}></Column>,
            <Column key="locationSubClassCode" dataField="locationSubClassCode" caption="Location SubClass" allowEditing={false} visible={false}></Column>,
            statusColumn("locationStatus", "Location Status"),
            ...userDefinedColumns("locationUserDefined", "Location"),
        ];
    }
    render() {
        return (
            <div className="row bg-white">
                <div className="col-md-12">
                    <div id="owner-ship-transfer-internal">
                        <DivLoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            visible={this.state.loadIndicatorVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                            id="ot-internal-loader-indicator"
                        />
                        <Prompt when={this.isTransferPending()} message={MESSAGES.OWNERSHIP_TRANSFER_NOT_APPLIED_EXIT} />
                        <ToolbarHdr className="header">
                            <ItemHdr location="before">
                                <div className="title">
                                    <h6
                                        style={{
                                            color: window._env_.Color2,
                                            marginLeft: '12px'
                                        }}
                                    >
                                        Internal Ownership Transfer
                                    </h6>
                                </div>
                            </ItemHdr>
                            <ItemHdr location="after">
                                <Button
                                    text="Apply"
                                    type="default"
                                    disabled={!!this.state.appliedResult || this.state.applying}
                                    className="accordianButton"
                                    onClick={this.onApplyClick}
                                />
                            </ItemHdr>
                            <ItemHdr location="after">
                                <Button
                                    text="Reset"
                                    className="accordianButton"
                                    onClick={this.ResetAll}
                                />
                            </ItemHdr>
                        </ToolbarHdr>
                        <>
                            <div className="AccordionItemBody">
                                {this.state.appliedResult && (
                                    <div
                                        className="pt-2 pl-3"
                                        style={{ color: window._env_.Color2, fontWeight: "bold" }}>
                                        {this.appliedMessage()}
                                    </div>
                                )}
                                <TabPanel stylingMode={'secondary'}
                                    selectedIndex={this.state.selectedTabIndex}
                                    onSelectionChanged={this.onTabSelectionChanged}
                                    className="TabpanelContainer">
                                    <TabPanelItem title="Shipment" disabled={false}>
                                        <div className="row pt-3">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    dataSource={this.state.shipment.arrShipmentProfile}
                                                    searchEnabled={true}
                                                    placeholder="Enter Profile"
                                                    disabled={!!this.state.appliedResult}
                                                    onSelectionChanged={this.ShipmentProfileChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    className="owner-ship-transfer-internal-dropdown"
                                                    acceptCustomValue={true}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Profile:"
                                                    value={this.state.shipment.profileId}
                                                    elementAttr={{
                                                        class: !this.state.shipment.profileId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentCustomerSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Customer"
                                                    onValueChanged={this.ShipmentCustomerChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.shipment.customerId}
                                                    acceptCustomValue={true}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Customer:"
                                                    elementAttr={{
                                                        class: !this.state.shipment.customerId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.shipment.transDate}
                                                    min={new Date(1900, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("transDate", e.value)}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Date:"
                                                    elementAttr={{
                                                        class: !this.state.shipment.transDate ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-transaction-no"
                                                    disabled={!!this.state.appliedResult}
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Transaction No."
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("transactionNo", e.value)}
                                                    name="shipment-trans-No"
                                                    value={this.state.shipment.transactionNo}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Transaction #:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentShipperSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Shipper"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("shipperId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.shipperId}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentConsigneeSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Consignee"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("consigneeId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.consigneeId}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Consignee:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentStageSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Stage"
                                                    items={this.arrStage}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    value={this.state.shipment.stage}
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("stage", e.value)}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Stage:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentStatusSelectBox}
                                                    items={this.statusItems(this.state.shipment.stage)}
                                                    searchEnabled={true}
                                                    placeholder="Enter Status"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("status", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    value={this.state.shipment.status}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Status:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.shipment.shipDate}
                                                    min={new Date(2000, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("shipDate", e.value)}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Ship Date:"
                                                    elementAttr={{
                                                        class: !this.state.shipment.shipDate ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-shipper-no"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Shipper #"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("shipperBolNo", e.value)}
                                                    name="shipment-shipper-no"
                                                    value={this.state.shipment.shipperBolNo}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper #:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-po-reference"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter PO Reference"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("poReference", e.value)}
                                                    name="shipment-po-ref"
                                                    value={this.state.shipment.poReference}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="PO Reference:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentRateSchdSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Rate Schedule"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("rateScheduleId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.rateScheduleId}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Rate Schedule:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-transaction-Group"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Trans Group"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("transGroup", e.value)}
                                                    name="shipment-trans-group"
                                                    value={this.state.shipment.transGroup}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Group:"
                                                />
                                            </div>
                                            <div className="col-md-9">
                                                <TextArea
                                                    id="shipment-comment"
                                                    className="input-field"
                                                    placeholder="Enter Comment"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("comment", e.value)}
                                                    name="shipment-comment"
                                                    value={this.state.shipment.comment}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    height={90}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Comment:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-12">
                                                <h6 style={{ color: window._env_.Color2 }}>User Defined</h6>
                                                <UserDefinedFieldsTab
                                                    header={this.state.shipment}
                                                    codeOptions={this.state.userDefinedCodeOptions.shipment}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    onChange={(kind, index, value) => this.UserDefinedChanged('shipment', kind, index, value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="row">
                                                <div className="col-md-12 my-2">
                                                    <Button
                                                        text="Next"
                                                        type="default"
                                                        stylingMode="contained"
                                                        onClick={this.onShipmentClickNext}
                                                    /></div>
                                            </div>
                                        </div>
                                    </TabPanelItem>
                                    <TabPanelItem title="Receipt"
                                        disabled={this.state.isTabDisabled}>
                                        <div className="row pt-3">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptDatabaseSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Facility"
                                                    disabled={!!this.state.appliedResult}
                                                    onSelectionChanged={this.DatabaseValueChanged}
                                                    displayExpr="text"
                                                    valueExpr="value"
                                                    value={this.state.receipt.databaseId}
                                                    acceptCustomValue={true}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Select Facility:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.databaseId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptProfileSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Profile"
                                                    disabled={!!this.state.appliedResult}
                                                    onValueChanged={this.ReceiptProfileChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.profileId}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Profile:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.profileId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptCustomerSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Customer"
                                                    onValueChanged={this.ReceiptCustomerValuesChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.receipt.customerId}
                                                    acceptCustomValue={true}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Customer:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.customerId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.receipt.transDate}
                                                    min={new Date(2000, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transDate", e.value)}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Date:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-transaction-no"
                                                    disabled={!!this.state.appliedResult}
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Transaction No."
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transactionNo", e.value)}
                                                    name="receipt-trans-No"
                                                    value={this.state.receipt.transactionNo}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Transaction #:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptShipperSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Shipper"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("shipperId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.receipt.shipperId}
                                                    acceptCustomValue={true}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptConsigneeSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Consignee"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("consigneeId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.consigneeId}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Consignee:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    items={this.arrStage}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    ref={receiptStageSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Stage"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("stage", e.value)}
                                                    value={this.state.receipt.stage}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Stage:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.stage ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptStatusSelectBox}
                                                    items={this.statusItems(this.state.receipt.stage)}
                                                    searchEnabled={true}
                                                    placeholder="Enter Status"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("status", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    value={this.state.receipt.status}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Status:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.status ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.receipt.recvDate}
                                                    min={new Date(2000, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("recvDate", e.value)}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Rec Date:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.recvDate ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-shipper-no"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Shipper #"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("shipperBolNo", e.value)}
                                                    name="receipt-shipper-no"
                                                    value={this.state.receipt.shipperBolNo}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper #:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-po-reference"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter PO Reference"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("poReference", e.value)}
                                                    name="shipment-po-ref"
                                                    value={this.state.receipt.poReference}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="PO Reference:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptRateSchdSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Rate Schedule"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("rateScheduleId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.rateScheduleId}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Rate Schedule:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-transaction-Group"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Trans Group"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transGroup", e.value)}
                                                    name="receipt-trans-group"
                                                    value={this.state.receipt.transGroup}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Group:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptItemProfileSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Item Profile"
                                                    disabled={!!this.state.appliedResult}
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("itemProfileId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.itemProfileId}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Item Profile:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptWarehouseSelectBox}
                                                    searchEnabled={true}
                                                    showClearButton={true}
                                                    placeholder="Enter Default Warehouse"
                                                    onValueChanged={this.ReceiptWarehouseChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.receipt.defaultWarehouseId}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Default Warehouse:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptLocationSelectBox}
                                                    searchEnabled={true}
                                                    showClearButton={true}
                                                    placeholder="Enter Default Location"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("defaultLocationId", e.value || "")}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.receipt.defaultLocationId}
                                                    disabled={this.state.receipt.receiptDisabled || !this.state.receipt.defaultWarehouseId}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Default Location:"
                                                    hint="Used when a source location does not exist in the receiving facility."
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-9">
                                                <TextArea
                                                    id="receipt-comment"
                                                    className="input-field"
                                                    placeholder="Enter Comment"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("comment", e.value)}
                                                    name="shipment-comment"
                                                    value={this.state.receipt.comment}
                                                    height={90}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Comment:"
                                                />
                                            </div>
                                            <div className="col-md-3 mt-4">
                                                <CheckBox
                                                    value={this.state.receipt.transferUnspecifiedSerialNumbers}
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transferUnspecifiedSerialNumbers", e.value)}
                                                    text="Transfer all unspecified Serial Numbers"
                                                    className="mr-2"
                                                    disabled={this.state.receipt.receiptDisabled}
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-12">
                                                <h6 style={{ color: window._env_.Color2 }}>User Defined</h6>
                                                <UserDefinedFieldsTab
                                                    header={this.state.receipt}
                                                    codeOptions={this.state.userDefinedCodeOptions.receipt}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    onChange={(kind, index, value) => this.UserDefinedChanged('receipt', kind, index, value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-12 my-2">
                                                <Button
                                                    text="Next"
                                                    type="default"
                                                    stylingMode="contained"
                                                    onClick={this.onReceiptClickNext}
                                                /></div>
                                        </div>
                                    </TabPanelItem>
                                    <TabPanelItem title="Select Inventory"
                                        disabled={!this.state.shipment.customerId}>
                                        <div className="row pt-3">
                                            <div className="col-md-6">
                                                <div
                                                    style={{
                                                        color: window._env_.Color2,
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                    }}>
                                                    Transfer Totals: <span className="pl-1 d-inline-block text-secondary">{this.state.inventorySelection.detailTransferQuantityCount}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <TabPanel stylingMode={'secondary'}
                                            selectedIndex={this.state.inventoryTabIndex}
                                            onSelectionChanged={this.onInventoryTabSelectionChanged}
                                            className="TabpanelContainer">
                                            <TabPanelItem title="Select Inventory">
                                                <div className="row">
                                                    <div className="col-md-12 main-page" >
                                                        <div id="accordion" >
                                                            <Accordion
                                                                dataSource={this.searchpanel}
                                                                className="accordion-height"
                                                                collapsible={true}
                                                                multiple={false}
                                                                animationDuration={300}
                                                                selectedItems={this.state.selectedItems}
                                                                onSelectionChanged={e => {
                                                                    if (e.currentTarget === e.target) {
                                                                        this.AccordionSelectionChanged(e);
                                                                    }
                                                                }}
                                                                itemTitleRender={() => (
                                                                    <ToolbarHdr className="accordian-toolbar">
                                                                        <ItemHdr location="before">
                                                                            <div className="title">
                                                                                <h6
                                                                                    style={{
                                                                                        color: window._env_.Color2
                                                                                    }}
                                                                                >
                                                                                    Filter Criteria
                                                                                </h6>
                                                                            </div>
                                                                        </ItemHdr>
                                                                        <ItemHdr location="after">
                                                                            <Button className="accordianButton" onClick={this.SearchGridFilter} type="default" text="Search" />
                                                                        </ItemHdr>
                                                                        <ItemHdr location="after">
                                                                            <Button className="accordianButton" onClick={this.ResetGridFilter} text="Reset" />
                                                                        </ItemHdr>
                                                                        <ItemHdr location="after">
                                                                            <Button className="accordianButton" onClick={this.ClearSelection} text="Clear Selection" disabled={!!this.state.appliedResult} />
                                                                        </ItemHdr>
                                                                    </ToolbarHdr>
                                                                )}
                                                                itemRender={(itemProps) => (
                                                                    <div>
                                                                        <div className="row">
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Item Code From:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodefrom}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Itemcodefrom', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Item Code To:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodeto}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Itemcodeto', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Lot Code From:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodefrom}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Lotcodefrom', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Lot Code To:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodeto}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Lotcodeto', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="row accordianLastRow">
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Item Desc From:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescfrom}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Itemdescfrom', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Item Desc To:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescto}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Itemdescto', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Lot Desc From:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescfrom}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Lotdescfrom', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <TextBox
                                                                                    label="Lot Desc To:"
                                                                                    value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescto}
                                                                                    onValueChanged={(data) => this.updateFilterCriteria('Lotdescto', data.value)}
                                                                                    stylingMode='outlined'
                                                                                    labelMode="static"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                id="accordion-container"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <DataGrid
                                                        onExporting={(e) => {
                                                            if (window.handleDevExtremeDataGridExport) {
                                                                window.handleDevExtremeDataGridExport(e);
                                                            }
                                                        }}
                                                        ref={detailOTItemDataGrid}
                                                        dataSource={this.state.inventorySelection.itemGridArr}
                                                        keyExpr="key"
                                                        height={this.state.searchPanelStatus ? "calc(100vh - 400px)" : "calc(100vh - 290px)"}
                                                        hoverStateEnabled={true}
                                                        allowColumnResizing={true}
                                                        allowColumnReordering={true}
                                                        onSelectionChanged={(e) => this.DetailGridselectionChanged(e)}
                                                        selectedRowKeys={this.state.inventorySelection.selectedRowKeys}
                                                        onEditorPreparing={this.onEditorPreparing}
                                                        onEditingStart={this.onEditingStart}
                                                        showBorders={true}
                                                    >
                                                        <ColumnChooser
                                                            enabled={true}
                                                            title="Choose Column"
                                                            width={290}
                                                            height={290}
                                                            sortOrder="asc"
                                                        >
                                                            <ColumnChooserSearch
                                                                enabled={true}
                                                                editorOptions={{ placeholder: 'Search column' }} />
                                                        </ColumnChooser>
                                                        <Selection mode={this.state.appliedResult ? "none" : "multiple"} />
                                                        <ColumnHeaderFilter />
                                                        <Export enabled={true} allowExportSelectedData={true} text="Export" />
                                                        <Sorting visible={true} mode="multiple" />
                                                        <LoadPanel enabled={true} />
                                                        <Paging defaultPageSize={10} />
                                                        <Pager
                                                            visible={true}
                                                            showPageSizeSelector={true}
                                                            allowedPageSizes={[10, 20, 50, 500]}
                                                            showNavigationButtons={true}
                                                        />
                                                        <FilterRow visible={true} />
                                                        <FilterPanel visible={true} />
                                                        <HeaderFilter enabled={true} visible={false} />
                                                        <Editing mode="cell" allowUpdating={!this.state.appliedResult} refreshMode="repaint" />
                                                        <GroupPanel visible={true} />
                                                        <Grouping autoExpandAll={false} />
                                                        <StateStoring
                                                            enabled={true}
                                                            type="custom"
                                                            customLoad={this.detailGridLoadState}
                                                            storageKey={detailGridKey}
                                                            customSave={this.detailGridSaveState}
                                                        />
                                                        <Scrolling rowRenderingMode="virtual" />
                                                        <LoadPanel enabled={true} />
                                                        {this.editableColumns()}
                                                        {this.inventoryColumns()}
                                                        <Toolbar>
                                                            <Item location="after">
                                                                <GridLayoutManager
                                                                    gridKey={detailGridKey}
                                                                    dataGrid={detailOTItemDataGrid}
                                                                    setCurrentLayout={this.setCurrentLayout} />
                                                            </Item>
                                                            <Item name="exportButton" />
                                                            <Item name="columnChooserButton" />
                                                        </Toolbar>
                                                    </DataGrid>
                                                </div>
                                            </TabPanelItem>
                                            <TabPanelItem title="Selected Inventory">
                                                <div className="pt-2">
                                                    {/* No layout storing here: restoring a saved layout resets the grid's selection, which on this
                                                        grid would drop every row from the transfer. */}
                                                    <DataGrid
                                                        onExporting={(e) => {
                                                            if (window.handleDevExtremeDataGridExport) {
                                                                window.handleDevExtremeDataGridExport(e);
                                                            }
                                                        }}
                                                        dataSource={this.state.inventorySelection.selectedGridArr}
                                                        keyExpr="key"
                                                        height="calc(100vh - 260px)"
                                                        hoverStateEnabled={true}
                                                        allowColumnResizing={true}
                                                        allowColumnReordering={true}
                                                        onSelectionChanged={this.DetailGridselectionChanged}
                                                        selectedRowKeys={this.state.inventorySelection.selectedRowKeys}
                                                        onEditorPreparing={this.onEditorPreparing}
                                                        onEditingStart={this.onEditingStart}
                                                        showBorders={true}
                                                    >
                                                        <ColumnChooser
                                                            enabled={true}
                                                            title="Choose Column"
                                                            width={290}
                                                            height={290}
                                                            sortOrder="asc"
                                                        >
                                                            <ColumnChooserSearch
                                                                enabled={true}
                                                                editorOptions={{ placeholder: 'Search column' }} />
                                                        </ColumnChooser>
                                                        {/* Every row here is selected; unticking one removes it from the transfer. Checkboxes only, so
                                                            clicking a cell to edit it never changes the selection, and no select-all to drop them all. */}
                                                        <Selection mode={this.state.appliedResult ? "none" : "multiple"} showCheckBoxesMode="always" allowSelectAll={false} />
                                                        <ColumnHeaderFilter />
                                                        <Export enabled={true} text="Export" />
                                                        <Sorting visible={true} mode="multiple" />
                                                        <LoadPanel enabled={true} />
                                                        <Paging defaultPageSize={10} />
                                                        <Pager
                                                            visible={true}
                                                            showPageSizeSelector={true}
                                                            allowedPageSizes={[10, 20, 50, 500]}
                                                            showNavigationButtons={true}
                                                        />
                                                        <FilterRow visible={true} />
                                                        <FilterPanel visible={true} />
                                                        <HeaderFilter enabled={true} visible={false} />
                                                        <Editing mode="cell" allowUpdating={!this.state.appliedResult} />
                                                        <GroupPanel visible={true} />
                                                        <Grouping autoExpandAll={false} />
                                                        <Scrolling rowRenderingMode="virtual" />
                                                        {this.editableColumns({ withItemCode: true })}
                                                        {this.inventoryColumns()}
                                                        <Toolbar>
                                                            <Item name="exportButton" />
                                                            <Item name="columnChooserButton" />
                                                        </Toolbar>
                                                    </DataGrid>
                                                </div>
                                            </TabPanelItem>
                                        </TabPanel>
                                    </TabPanelItem>
                                </TabPanel>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(OwnershipTransferInternal);